import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_LEAVE_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const LeaveReport = lazy(() =>
  import('../../../screens/LeaveReport')
    .then(module => ({default: module.LeaveReport})));

const LeaveReportNavigation = [
  {
    path: ROUTE_LEAVE_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <LeaveReport />
      </Suspense>
    ),
  },
];

export default LeaveReportNavigation;
